import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import reloadToken from '../helper/reloadtoken';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.min.css';
import HeaderMenu from '../template/HeaderMenu';

const host = process.env.REACT_APP_API_URL_ONLINE;
const hostupload = process.env.REACT_APP_API_HOST_UPLOAD;

const User_c_pass = () => {
  const hotRef = useRef(null);
  const [token, setToken] = useState(null);
  const [accessCode, setAccessCode] = useState('');
  const [colHeaders, setColHeaders] = useState([]);
  const widthLayout = window.innerWidth - 10;
  const heightLayout = window.innerHeight - 10;

  useEffect( async () => {
    
    localStorage.setItem('token', null);
    localStorage.setItem('user', null);
    localStorage.setItem('pass', null);
    localStorage.setItem("pengguna", null);
    localStorage.setItem("master_field", null);
    localStorage.setItem("role", null);
    setTimeout(function() {
      window.location.href = '/'
    }, 2000);
  }, []);

  return (
    <div>
       <HeaderMenu title="Logout"/>
      <div style={{ width:'100%', margin:"20px auto", textAlign:"left"}}>
        <form>
          <div>
            <label htmlFor="currentPassword">You Have Been Logout</label><br/>
          </div>
        </form>
      </div>
    </div>
  );
};

export default User_c_pass;
